// import Log from '../core/logging';

import { makeType, parseOptions, initLog } from "../core/base"

import Dispatcher from "../core/dispatcher-flyd"

import UI from "../core/ui"

const proto = {
    name: "SlideShowNavigator",
    dom: null,
    thumbnails: null,

    parseOptions,
    initLog,
    defaultOptions: {
        panelRole: "slideshow-slide-thumbnail"
    },

    initialize(dom) {
        this.dom = dom
        this.initLog ()

        this.parseOptions ()

        // this.log.enable ()

        // this.log.warn (`options:`, {... this.options})

        let thumbnails = dom.findByRole (this.options.panelRole)

        if (dom.dataset.keepOrphans == null) {
            if (thumbnails.length < 2) {
                //  no need for navigator
                this.dom.dispose()
                return
            }
        }

        if (dom.dataset.targetRole) {
            this.target = document.findByRole (dom.dataset.targetRole)
        } else if (dom.dataset.target) {
            this.target = document.getElementById (dom.dataset.target)
        } else {
            this.target = dom.getParentByRole ("slideshow-gallery")
        }

        this.markActiveByThumbnail (thumbnails[0])

        thumbnails.forEach ((t, c) => {
            t.addEvent ("click", ev => {
                ev.preventDefault ()

                if (t.dataset.path) {
                    window.history.replaceState ({}, "", t.dataset.path)
                    Dispatcher.dispatch ({
                        type: "gallery-showslide",
                        target: this.target,
                        path: t.dataset.path,
                        thumbnail: t
                    })
                } else {
                    Dispatcher.dispatch ({
                        type: "gallery-showslide",
                        target: this.target,
                        number: c
                    })
                }
                this.markActiveByThumbnail (t)
            })
        })

        Dispatcher.map (msg => {
            if (msg.type === "gallery-panelshown") {
                if (msg.target === this.target) {
                    if (msg.path) {
                        dom.findByRole (this.options.panelRole)
                            .filter (t => t.dataset.path === msg.path)
                            .forEach (t => this.markActiveByThumbnail (t))
                    } else {
                        if (msg.thumbnail) {
                            this.markActiveByThumbnail (msg.thumbnail)
                        } else {
                            this.markActiveByIndex (msg.number)
                        }
                    }
                }
            }
        })
    },

    markActiveByIndex(idx) {
        let thumbnails = this.dom.findByRole (this.options.panelRole)

        thumbnails.forEach (t => t.removeClass ("active"))
        if (thumbnails[idx]) {
            thumbnails[idx].addClass ("active")
        }
    },

    markActiveByThumbnail(thumbnail) {
        this.dom
            .findByRole (this.options.panelRole)
            .forEach (t => t.removeClass ("active"))

        thumbnail.addClass ("active")
    },

    panelShown(panel) {
        // this.log.trace ("panelShown:", panel)
        this.markActiveByIndex (panel)
    }
}

export const SlideShowNavigator = makeType (proto)

UI.register ("slideshow-navigator", SlideShowNavigator)
